// extracted by mini-css-extract-plugin
export default {"switch":"LargeSwitch_switch__rBRC5","disabled":"LargeSwitch_disabled__E5T-E"};